import AdminApi from '../../services/api'
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import { formatChatDate } from "./ChatDateUtils";
import ChooseUserModal from "../../modals/ChooseUserModal.vue";
import swal from "sweetalert2";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            conversations: [],
            searchQuery: '',
            activeStatus: 'ACTIVE',
            chooseUser: false,
            selectedUser: null,
            isLoading: false,
            errorMessage: '',
            page: 0,
            limit: 20
        }
    },
    computed: {
        filteredConversations: filteredConversations
    },
    methods: {
        loadConversations: loadConversations,
        openConversation: openConversation,
        startConversation: startConversation,
        changeStatus: changeStatus,
        closeConversation: closeConversation,
        openFaq: openFaq,
        chooseUserDialog: chooseUserDialog,
        startConversationWithSelectedUser: startConversationWithSelectedUser,
        canStartConversation: canStartConversation,
        isStaffChat: isStaffChat,
        getConversationName: getConversationName,
        getTargetLabel: getTargetLabel,
        getTargetInitial: getTargetInitial,
        formatDate: formatDate,
        buildQuery: buildQuery
    },
    components: {
        ChooseUserModal
    },
    beforeMount() {
        if (!canUseUserChat()) {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.loadConversations();
    },
    created() {
        this._closeChooseUserHandler = () => {
            this.chooseUser = false;
        };
        this._onUserSelectedHandler = (data) => {
            this.chooseUser = false;
            this.selectedUser = data;
        };
        this.$topnavbar.$on('closeChooseUser', this._closeChooseUserHandler);
        this.$topnavbar.$on('onUserSelected', this._onUserSelectedHandler);
    },
    destroyed() {
        this.$topnavbar.$off('closeChooseUser', this._closeChooseUserHandler);
        this.$topnavbar.$off('onUserSelected', this._onUserSelectedHandler);
    }
}

function canUseUserChat() {
    return ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(session.getRole());
}

function canStartConversation() {
    return session.getRole() === 'ROLE_USER';
}

function isStaffChat() {
    return ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(session.getRole());
}

function filteredConversations() {
    if (!isStaffChat()) return this.conversations;
    let query = (this.searchQuery || '').toLowerCase().trim();
    if (query.length === 0) return this.conversations;
    return this.conversations.filter(conversation => {
        let fullName = getConversationName(conversation) || '';
        let username = conversation.username || '';
        let name = conversation.name || '';
        let surname = conversation.surname || '';
        return fullName.toLowerCase().indexOf(query) !== -1 ||
            username.toLowerCase().indexOf(query) !== -1 ||
            name.toLowerCase().indexOf(query) !== -1 ||
            surname.toLowerCase().indexOf(query) !== -1;
    });
}

function loadConversations() {
    this.isLoading = true;
    this.errorMessage = '';
    let status = isStaffChat() ? this.activeStatus : null;
    AdminApiService.getChatConversations(this.page, this.limit, status)
        .then((response) => {
            this.conversations = response.data != null && response.data.results != null ? response.data.results : [];
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isLoading = false;
        })
}

function changeStatus(status) {
    if (this.activeStatus === status) return;
    this.activeStatus = status;
    this.page = 0;
    this.selectedUser = null;
    this.loadConversations();
}

function openConversation(conversation) {
    this.$router.push({
        path: '/user-chat-conversation',
        query: this.buildQuery({
            id: conversation.id
        })
    });
}

function closeConversation(conversation) {
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_close_conversation_confirm'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then((result) => {
        if (result != null && (result.dismiss != null || result.value === false)) return;
        AdminApiService.closeChatConversation(conversation.id)
            .then(() => {
                this.loadConversations();
            })
            .catch(error => {
                this.errorMessage = getErrorMessage(error);
            })
    }).catch(() => {});
}

function startConversation(targetType) {
    this.$router.push({
        path: '/user-chat-conversation',
        query: this.buildQuery({
            targetType: targetType
        })
    });
}

function openFaq() {
    this.$router.push({
        path: '/chat-faq',
        query: this.buildQuery({
            back: 'user'
        })
    });
}

function chooseUserDialog() {
    this.chooseUser = true;
}

function startConversationWithSelectedUser() {
    if (this.selectedUser == null) return;
    this.$router.push({
        path: '/user-chat-conversation',
        query: this.buildQuery({
            userId: this.selectedUser.id,
            userName: ((this.selectedUser.name || '') + ' ' + (this.selectedUser.surname || '')).trim()
        })
    });
}

function buildQuery(extraQuery) {
    let query = Object.assign({}, extraQuery);
    if (this.$route.query.programToken != null) {
        query.programToken = this.$route.query.programToken;
    }
    if (this.$route.query.locale != null) {
        query.locale = this.$route.query.locale;
    }
    return query;
}

function getConversationName(conversation) {
    let fullName = ((conversation.name || '') + ' ' + (conversation.surname || '')).trim();
    return fullName.length > 0 ? fullName : conversation.username;
}

function getTargetLabel(conversation) {
    return conversation.targetType === 'TRAINER'
        ? LocService.t('label_trainer')
        : LocService.t('label_admin');
}

function getTargetInitial(conversation) {
    return conversation.targetType === 'TRAINER'
        ? LocService.t('label_trainer').charAt(0)
        : LocService.t('label_admin').charAt(0);
}

function formatDate(value) {
    return formatChatDate(value);
}

function getErrorMessage(error) {
    if (error != null && error.data != null && error.data.localized_error_message != null) {
        return error.data.localized_error_message;
    }
    return LocService.t('label_chat_load_error');
}



// WEBPACK FOOTER //
// ./src/components/Chat/UserChat.js